import { RootState } from "../store";

export const selectPlansType = (state: RootState) => state.plansType.plansType;
export const selectErrorMessagePlansType = (state: RootState) => state.plansType.errorMessage;
